import { SecurityService, SecurityProvider, HttpService, FirewallProvider, IpAddressProvider } from '@lk/api'

export const makeSecurityService = (http: HttpService, baseUrl: string) =>
  new SecurityService(
    new SecurityProvider(http, baseUrl),
    new FirewallProvider(http, baseUrl),
    new IpAddressProvider(http, baseUrl),
  )
